export class Order {
    id: number;
    order_number: number;
    user_id: number;
    shoppingcart_id: number;
    status: string;
    total_incl: number;
    total_excl: number;
    total_base_incl: number;
    total_base_excl: number;
    shipping_incl: number;
    shipping_excl: number;
    shipping_tax: number;

    user_name: string;
    user_gender: string;
    user_company_name: string;
    user_company_vat_number: string;
    user_customer_id: string;
    user_zipcode: string;
    user_address: string;
    user_housenumber: string;
    user_city: string;
    user_country_id: string;
    user_telephone: string;
    user_email: string;
    user_language: string;

    billing_name: string;
    billing_company_name: string;
    billing_zipcode: string;
    billing_address: string;
    billing_housenumber: string;
    billing_city: string;
    billing_country_id: string;
    billing_telephone: string;
    billing_email: string;

    delivery_name: string;
    delivery_company_name: string;
    delivery_zipcode: string;
    delivery_address: string;
    delivery_housenumber: string;
    delivery_city: string;
    delivery_country_id: string;
    delivery_telephone: string;
    delivery_email: string;
    tnt_code: string;

    voucher_id: number;
    
    payment_session: string;
    payment_mollie_id: string;
    payment_method: string;
    payment_provider_status: string;
    payment_status: string;
    payment_paid: boolean;

    comments: string;
    crm_offer_id: number;

    purchased_at: string;
    paid_at: string;
    created_at: string;
    updated_at: string;
    deleted_at: string;
    
    // Not in database
    total_sum_incl: number;
    total_sum_excl: number;
    total_sum_tax: number;
    tax_totals: number;
}


// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/models/shop/order.ts